import '@babel/polyfill'
import App from 'app'
import Login from 'login'
import Analytics from 'libraries/analytics'
import 'modules/reporting'
import 'modules/dashboard'
import 'modules/tableauDashboard'
import 'modules/agents'
import 'modules/newAgents'
import 'modules/research'
import 'modules/settings'
import 'modules/newsroom'
import 'modules/notifications'
import 'modules/navigation'
import 'modules/styleguide'
import 'modules/sandbox'
import 'modules/relativeTimes'
import 'modules/shortcuts'
import 'modules/shortcutsHelp'
import 'modules/commonInitializer'
import Deferred from 'libraries/deferred'

Analytics.init();

Login.start();

const appStarter = Deferred.build();
Analytics.userTiming('br_startup_time', appStarter);

Login.whenLoggedIn(function () {
  App.loadSession().done(function () {
    App.module('Agents').on('loaded', appStarter.resolve)
    App.start();
  });
});
